<template>
    <span class="uv-container" data-uv-trigger>
        <div class="img-size chat-icon"></div>
        <span class="span-label" v-if="showLabel">{{
            $t('labelUserVoice')
        }}</span>
    </span>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        props: { showLabel: { type: Boolean, required: false, default: false } },

        async mounted() {
            await (function (d) {
                const scriptFile =
                    '//cadac.uservoice.com/widget_environment/U0fAv5fNJlkYXKSXAMOcw.js';

                // generate uservoice script object
                var script = d.createElement('script');
                script.type = 'text/javascript';
                script.async = true;
                script.src = scriptFile;

                // load the script
                const promise = new Promise((resolve, reject) => {
                    script.onload = () => resolve();
                    script.onerror = (event) => reject(event);
                });

                // check is the script was inserted before
                let doInsert = true;
                const scriptArray = d.getElementsByTagName('script');
                for (const element of scriptArray) {
                    if (element.src.endsWith(scriptFile)) {
                        doInsert = false;
                        break;
                    }
                }

                // insert the script
                if (doInsert) {
                    const insertionPoint = d.getElementsByTagName('script')[0];
                    insertionPoint.parentNode.insertBefore(script, insertionPoint);
                }

                return promise;
            })(document);

            // load uservoice now the script is inserted
            this.loadedUserVoice();
        },

        computed: {
            ...mapGetters(['isMobile', 'getUserData', 'getUserInfo']),
            userInfo() {
                return this.isMobile && this.getUserInfo !== undefined
                    ? this.getUserInfo
                    : this.$store.state.userInfo;
            }
        },

        methods: {
            loadedUserVoice() {
                // global settings
                window.UserVoice.push([
                    'set',
                    {
                        accent_color: '#007ac9', // color of Next button
                        forum_id: '951097-cadac-nedglobe' // defaults to Cadac account’s default forum
                    }
                ]);

                const email = this.userInfo.userName ?? '';
                const name = email.split('@')[0] ?? '';
                const id = this.userInfo.userID ?? '';

                // Identify the user and pass traits
                window.UserVoice.push([
                    'identify',
                    {
                        email,
                        name,
                        id
                    }
                ]);
            }
        }
    };
</script>

<style scoped lang="scss">
.uv-container {
    display: inline-flex;

    .img-size {
        width: 20px;
        height: 20px;
        background-size: 20px;
        mask-size: 20px;
    }
    .span-label {
        padding-left: 8px;
    }
}
</style>
